import { GMap, GMarker } from '../components/maps'
import BlogNewsletter from '../components/blog-newsletter'
import { NavSlider, NavSliderItem } from '../components/nav-slider'

import { Loader } from 'google-maps'

export default {
  name: 'Location',
  components: {
    BlogNewsletter,
    NavSlider,
    NavSliderItem,
    GMap,
    GMarker,
  },
  data() {
    return {
      mapLoader: null,
      canLoad: false,
    }
  },
  beforeMount() {
    if (window.BorlabsCookie.checkCookieConsent('googlemaps')) {
      this.canLoad = true
    } else {
      document.addEventListener('borlabs-cookie-consent-saved', () => {
        if (window.BorlabsCookie.checkCookieConsent('googlemaps')) {
          this.canLoad = true
        }
      })
    }
  },
  mounted() {
    new Loader('AIzaSyAWX6gvQvX8texhBVGk09hoe6Tjpd4j8uw').load().then(google => {
      this.mapLoader = google
    })
  },
}
